import { BrowserRouter, Switch, Route } from "react-router-dom";
import NotFound from "./containers/NotFound";
import NavBar from "./components/NavBar";
import Login from "./containers/Login";
import AdminDashboard from "./containers/Admin/Dashboard"
import MainNews from "./containers/news"
import Admin from "./containers/Admin";
import AdminUsers from "./containers/Admin/Users";
import Account from "./containers/Account";
import AdminLocations from "./containers/Admin/Locations";
import AdminCategories from "./containers/Admin/Categories";
import AdminNews from "./containers/Admin/News"
import Editor from "./containers/Editor"
import EntNews from "./containers/Editor/News"
import About from "./containers/About"
import products from "./containers/products"
import tutoriais from "./containers/Admin/tutoriais"
import analysis from "./containers/analysis"
import { SearchProvider } from "./contexts/SearchContext"
import AdminRibbonBadges from "./containers/Admin/ribbonBadges";
import AdminTypes from "./containers/Admin/type"
import New from "./containers/news/new";
import Analise from "./containers/analysis/analysi";
import AdminComments from './containers/Admin/comments';
export default function Routes() {

    return (
        <BrowserRouter>
            <SearchProvider>
                <NavBar />
                <Switch>
                    <Route exact path="/" component={MainNews} />
                    <Route exact path="/ofertas" component={products} />
                    <Route exact path="/ofertas/:idCategory" component={products} />
                    <Route exact path="/analises" component={analysis} />
                    <Route exact path="/new/:slug" component={New} />
                    <Route exact path="/analise/:slug" component={Analise} />
                    <Route path="/conta" component={Account} />
                    <Route path="/entrar" component={Login} />
                    <Route exact path="/sobre" component={About} />
                    <Route path="/conta" component={Account} />
                    <Route path="/categoria/:idCategory" component={MainNews} />
                    <Route path="/editor/news" component={EntNews} />
                    <Route path="/editor" component={Editor} />
                    <Route path="/admin/dashboard" component={AdminDashboard} />
                    <Route path="/admin/usuarios" component={AdminUsers} />
                    <Route path="/admin/localidades" component={AdminLocations} />
                    <Route path="/admin/categorias" component={AdminCategories} />
                    <Route path="/admin/news" component={AdminNews} />
                    <Route path="/admin/ribbon-badges" component={AdminRibbonBadges} />
                    <Route path="/admin/tipo-publicacao" component={AdminTypes} />
                    <Route path="/admin/comentarios" component={AdminComments} />
                    <Route path="/admin/tutoriais" component={tutoriais} />
                    <Route path="/admin" component={Admin} />
                    <Route component={NotFound} />
                </Switch>
            </SearchProvider>
        </BrowserRouter>

    );

}